import {computed, ref, watch} from 'vue';
import {Skill} from '../types/Skill';
import {useGlobalProperties} from '@malt/vue3-use';

type Props = {
    skills: Skill[];
    maxCount: number;
    placeholderCount: number;
    showRemoveButton: boolean;
    isOptionalSkills: boolean;
};

export function useSkillsBuilder(props: Props) {
    const dragging = ref<boolean>(false);
    const skillsModel = ref<Skill[]>([]);

    const placeholdersCount = computed(() => {
        return Math.max(props.placeholderCount - props.skills.length, 0);
    });

    function skillsWithPlaceholder() {
        const placeholders: Skill[] = [];
        for (let i = 0; i < placeholdersCount.value; i++) {
            const skill = new Skill(`__placeholder-${i}__`);
            skill.placeholder = true;
            placeholders.push(skill);
        }
        return [...props.skills, ...placeholders];
    }

    watch(
        () => props.skills,
        () => {
            skillsModel.value = skillsWithPlaceholder();
        },
        {immediate: true, deep: true},
    );

    return {
        dragging,
        skillsModel,
    };
}
